module.exports = __webpack_public_path__ + "img/collection-diamondJewelryGold@2x.ad4eb2b.webp";